module.exports = "/images/app-store-logo.png?390ef4f759c0ae0b0d6a4339befc8995";